import Modal from "react-bootstrap/Modal";
import { Table, Badge, ProgressBar, Button, Form } from "react-bootstrap";
import { IconFileText, IconChevronRight } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import moment from "moment";
import DynamicPagination from "../../components/DynamicPagination ";

function PdfProductsPopup({ show, onClose, autoId, onSubmitSuccess }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [selectedAutoIds, setSelectedAutoIds] = useState([]);

  const { data: documentData, postData: fetchData } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_FBOP,
  );

  const { data: fbopProducts, postData: getFbop } = usePostRequest(
    API_ENDPOINTS.GET_FBOP_PRODUCTS,
  );

  useEffect(() => {
    if (!show || !autoId) return;
      const payload = { page: page, limit: limit, auto_id: autoId };
      fetchData(payload);
  }, [page, limit, autoId]);

  // Clear selections whenever the modal's autoId changes (new document opened)
  useEffect(() => {
    setSelectedAutoIds([]);
  }, [autoId]);

  const handleCheckboxChange = (docAutoId, isChecked) => {
    setSelectedAutoIds((prev) =>
      isChecked ? [...prev, docAutoId] : prev.filter((id) => id !== docAutoId),
    );
  };

  //   const handleSubmit = () => {
  //     if (selectedAutoIds.length === 0) return;
  //     getFbop({ data_auto_id: selectedAutoIds });
  //   };

  const handleSubmit = () => {
    if (selectedAutoIds.length === 0) return;
    getFbop({ data_auto_id: selectedAutoIds }, (res) => {
      if (res?.products?.length > 0) {
        onSubmitSuccess(res.products);
        onClose();
        setSelectedAutoIds([]);
      }
    });
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleSelectAll = () => {
    const allIds = documentData?.data?.map((doc) => doc?.auto_id) || [];
    setSelectedAutoIds((prev) => {
      const newIds = allIds.filter((id) => !prev.includes(id));
      return [...prev, ...newIds];
    });
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      dialogClassName="modal-xl"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          FBOP Validated Forms
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive">
          <Table className="mb-3 align-middle">
            <thead className="bg-light">
              <tr
                style={{
                  fontSize: "0.85rem",
                  textTransform: "uppercase",
                  color: "#6c757d",
                }}
              >
                <th className="ps-4 py-3">Select</th>
                <th className="py-3">Carrier Type</th>
                <th className="py-3">Carrier Qty</th>
                <th className="py-3">First Name</th>
                <th className="py-3">Last Name</th>
                <th className="py-3 text-end pe-4">Report Date</th>
              </tr>
            </thead>
            <tbody>
              {documentData?.data?.map((doc, index) => {
                const isChecked = selectedAutoIds.includes(doc?.auto_id);
                return (
                  <tr
                    key={doc.id}
                    style={{
                      fontSize: "0.95rem",
                      backgroundColor: isChecked
                        ? "rgba(254, 99, 56, 0.06)"
                        : "transparent",
                    }}
                  >
                    <td className="ps-4 text-muted">
                      <Form.Check
                        type="checkbox"
                        id={`select-product-${doc?.auto_id}`}
                        label=""
                        checked={isChecked}
                        onChange={(e) =>
                          handleCheckboxChange(doc?.auto_id, e.target.checked)
                        }
                      />
                    </td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <span
                          className="fw-medium"
                          style={{ color: "#374151" }}
                        >
                          {doc?.v_carrier_type}
                        </span>
                      </div>
                    </td>
                    <td className="ps-4 text-muted">
                      <span className="fw-medium" style={{ color: "#374151" }}>
                        {doc?.v_carrier_qty}
                      </span>
                    </td>
                    <td className="ps-4 text-muted">
                      <span className="fw-medium" style={{ color: "#374151" }}>
                        {doc?.officer_first_name}
                      </span>
                    </td>
                    <td className="ps-4 text-muted">
                      <span className="fw-medium" style={{ color: "#374151" }}>
                        {doc?.officer_last_name}
                      </span>
                    </td>
                    <td className="pe-4 ps-4 text-muted text-end">
                      {moment(doc?.date).format("MM/DD/YYYY HH:mm")}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          <div className="d-flex align-items-center gap-3 mb-2 justify-content-center">
            {documentData?.data?.some(
              (doc) => !selectedAutoIds.includes(doc?.auto_id),
            ) && (
              <span
                style={{
                  fontSize: "0.85rem",
                  color: "#6c757d",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={handleSelectAll}
              >
                Select all
              </span>
            )}

            <Button
              onClick={handleSubmit}
              disabled={selectedAutoIds.length === 0}
              className="d-flex align-items-center gap-2 px-4 py-2"
              style={{
                backgroundColor:
                  selectedAutoIds.length === 0 ? "#ccc" : "#FE6338",
                border: "none",
                borderRadius: "8px",
              }}
            >
              Submit
            </Button>

            {selectedAutoIds.length > 0 && (
              <span
                style={{
                  fontSize: "0.85rem",
                  color: "#6c757d",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => setSelectedAutoIds([])}
              >
                Clear selection
              </span>
            )}
          </div>
        </div>

        {documentData?.data?.length > 0 && (
          <DynamicPagination
            totalPages={documentData?.pagination?.totalPages}
            currentPage={page}
            onPageChange={handlePageChange}
            limitPerPage={limit}
            onLimitChange={handleLimitChange}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

export default PdfProductsPopup;
